import React, { Component } from 'react';
import logo from './logo.svg';
import './contract.css';
import {
  Navbar,
  Nav,
  NavItem,
  Grid,
  Row,
  Col,
  Panel,
  Button
} from 'react-bootstrap';
import { CustomNav } from '../Components/CustomNav';
import { PlayerCard } from '../Components/PlayerCard';
import { WizardTable } from '../Components/WizardTable';
import { makeData, Logo, Tips } from '../Utility/utility.js';
import axios from 'axios';
import { apiServerUrl } from '../config';
import { authHeader, requestOptions } from '../_helpers';

let prospects = require('../Mock/prospects.json');

export class Wizard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prospects: prospects.players,
      selectedPlayer: '',
      selectedPlayer2: '',
      selection: 1,
      playerList: [],
      loading: true,
      columns: []
    };
  }

  render() {
    return (
      <div>
        <header class="nav">
          <CustomNav />
        </header>
        <div class="flex-grid">
          <WizardTable players={this.state.playerList} />
        </div>
      </div>
    );
  }
}

export default Wizard;



// WEBPACK FOOTER //
// ./src/Pages/Wizard.js